import { createContext, useContext } from 'react';
import { CreateShopFormType, ShopPolygonType } from 'utils/types';

export type ShopContextType = {
  createShopForm: CreateShopFormType;
  setCreateShopForm: (k: CreateShopFormType) => void;
  disabled: boolean;
  polygons: ShopPolygonType[];
  setDisabled: (k: boolean) => void;
  setPolygons: React.Dispatch<React.SetStateAction<ShopPolygonType[]>>;
  activePolygon: ShopPolygonType | null;
  setActivePolygon: React.Dispatch<React.SetStateAction<ShopPolygonType | null>>;
};

export const NewShopContext = createContext({} as ShopContextType);

const useNewShopContext = () => {
  const context = useContext(NewShopContext);
  return context;
};

export default useNewShopContext;
